/* globals Swal */

const confirm = async (options, callback = null) => {
    const params = options.params || [];

    const defaultOptions = {
        title: 'Are you sure?',
        showCloseButton: true,
        showCancelButton: true,
        allowOutsideClick: false,
        customClass: {
            confirmButton: 'btn btn-primary ca-confirm-confirm',
            cancelButton: 'btn btn-default ca-confirm-cancel',
        },
        confirmButtonText: '<i class="fas fa-check"></i> Yes, do it!',
        cancelButtonText: '<i class="fas fa-times"></i> Cancel',
        reverseButtons: true,
        position: 'top',
    };

    options = { ...defaultOptions, ...options };

    const apiErrorMsg = document.createElement('div');
    const apiErrorText = document.createElement('p');
    const apiErrorLink = document.createElement('a');

    apiErrorText.appendChild(
        document.createTextNode('This issue has been logged and the team is working on it. Please try again later, or ')
    );
    apiErrorLink.href = 'mailto:contact@spatialmedia.com.au';
    apiErrorLink.appendChild(document.createTextNode('contact support'));
    apiErrorText.appendChild(apiErrorLink);
    apiErrorText.appendChild(document.createTextNode(' if error persists.'));
    apiErrorMsg.appendChild(apiErrorText);

    const types = {
        info: {
            icon: 'info',
            iconHtml: '<i class="fas fa-exclamation"></i>',
        },
        warning: {
            icon: 'warning',
            iconHtml: '<i class="fas fa-exclamation"></i>',
            customClass: {
                confirmButton: 'btn btn-warning',
                cancelButton: 'btn btn-default',
            },
        },
        success: {
            icon: 'success',
            iconHtml: '<i class="fas fa-check"></i>',
            customClass: {
                confirmButton: 'btn btn-success',
            },
        },
        error: {
            icon: 'error',
            iconHtml: '<i class="fas fa-bomb"></i>',
            // showConfirmButton: false,
            cancelButtonText: '<i class="fas fa-times"></i> Close',
        },
        apiError: {
            icon: 'error',
            title: "We're sorry, but something went wrong",
            iconHtml: '<i class="fas fa-bomb"></i>',
            html: apiErrorMsg.outerHTML,
            showConfirmButton: false,
            cancelButtonText: '<i class="fas fa-times"></i> Close',
        },
        question: {
            icon: 'question',
            iconHtml: '<i class="fas fa-question"></i>',
        },
        delete: {
            icon: 'error',
            iconHtml: '<i class="fas fa-trash"></i>',
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-default',
            },
            confirmButtonText: '<i class="fas fa-trash"></i> Yes, delete everything forever!',
            cancelButtonText: '<i class="fas fa-times"></i> Cancel, don\'t delete anything.',
            allowOutsideClick: false,
        },
        remove: {
            icon: 'warning',
            iconHtml: '<i class="fas fa-slash"></i>',
            customClass: {
                confirmButton: 'btn btn-warning',
                cancelButton: 'btn btn-default',
            },
            confirmButtonText: '<i class="fas fa-trash"></i> Yes, remove everything forever!',
            cancelButtonText: '<i class="fas fa-times"></i> Cancel, don\'t remove anything.',
            allowOutsideClick: false,
        },
        download: {
            icon: 'info',
            title: 'Your download is ready!',
            iconHtml: '<i class="fas fa-download"></i>',
            showConfirmButton: false,
            showCancelButton: false,
        },
    };

    if (options.type) options = Object.assign({}, options, types[options.type]);

    // remove non swal options
    delete options.type;
    delete options.params;

    return await Swal.fire(options).then(async (result) => {
        if (result.value && callback) {
            return callback(...params); // call back should be a promise
        } else {
            return result;
        }
    });
};

export default confirm;
